import useVelocityClient from 'src/hooks/useVelocityClient';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';
import { fetchUserStatsAccount } from '@velocity-exchange/sdk';
import { QueryDisabledError } from 'src/utils/error/QueryDisabledError';
import { useQuery } from '@tanstack/react-query';
import { createQueryKey } from 'src/utils/query/createQueryKey';

function rootAuthorityUserStatsAccountQueryKey(authority?: string) {
	return createQueryKey('rootAuthorityUserStatsAccount', authority);
}

/**
 * Fetches the stats account for the "root" authority of the current account,
 * which may either be the connected wallet or the main wallet if the current
 * account is a delegate.
 */
export default function useRootAuthorityUserStatsAccount() {
	const connection = useVelocityStore((s) => s.connection.current);
	const velocityClient = useVelocityClient();
	const rootAuthority = useVelocityAccountStore(
		(s) => s.getCurrentUserAccount()?.authority
	);

	const disabled = !connection || !velocityClient?.program || !rootAuthority;

	const queryFn = () => {
		if (disabled) {
			throw new QueryDisabledError();
		}

		return fetchUserStatsAccount(
			connection,
			velocityClient?.program,
			rootAuthority
		);
	};

	return useQuery({
		queryKey: rootAuthorityUserStatsAccountQueryKey(
			rootAuthority?.toString() ?? ''
		),
		queryFn,
		enabled: !disabled,
	});
}
